import React, { Component } from "react";

import AgGridReactEx from "@app/components/AgGridReactEx";

import FlyEngConstants from "@app/config/FlyEngConstants";

export default class MainContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            tableData: null,
            keyword: null,
        };
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState(
            {
                data: nextProps.data,
            },
            () => {
                this.setState({ tableData: this.listSearch(this.state.keyword) });
            }
        );
    };

    defaultColDef = {
        editable: false,
        sortable: false,
        flex: 1,
        minWidth: 60,
        filter: false,
        resizable: true,
        cellClass: "text-center",
        headerClass:'bg-dark text-light',
    };

    listColumn = [
        {
            headerName: "콘텐츠명",
            field: "title",
            minWidth: 170,
        },
        {
            headerName: "카테고리",
            field: "categoryId",
            minWidth: 80,
            cellRenderer: (param) => {
                const category = FlyEngConstants.HOME.CATEGORY.find((c) => c.id === param.value);
                return category ? category.name : '-';
            },
        },
        {
            headerName: "레벨",
            field: "age",
            minWidth: 90,
            cellRenderer: (param) => {
                const level = FlyEngConstants.LEVEL.find((l) => l.age === param.value);
                return level ? `레벨${level.name}` : '-';
            },
        },
        {
            headerName: "메뉴",
            field: "path",
            minWidth: 90,
            cellRenderer: (param) => {
                return param.value;
            },
        },
        {
            headerName: "실행수",
            field: "cnt",
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
        {
            headerName: "누적 실행수",
            field: "cntSum",
            cellRenderer: (param) => {
                return param.value ? param.value.toLocaleString() : "-";
            },
        },
    ];

    listSearch = (keyword) => {
        var list = this.state.data;
        var tableData = [];
        if (!keyword) {
            tableData = list;
        } else {
            list.map((item) => {
                if (item.nurseryName && item.nurseryName.indexOf(keyword) >= 0) {
                    tableData.push(item);
                }
            });
        }
        return tableData;
    };

    render() {
        if (this.state.tableData == null) {
            return (
                <div style={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <span className="dashboard-spinner spinner-lg"></span>
                </div>
            );
        } else {
            return (
                    <AgGridReactEx
                        height="250"
                        defaultColDef={this.defaultColDef}
                        columnDefs={this.listColumn}
                        rowData={this.state.tableData}
                        pagination={false}
                    />
            );
        }
    }
}
